import React from 'react';
import './arrepentimiento-estado.css';

const ArrepentimientoEstado = (props) => {
  return (
    <div className='consulta-exitosa' style={{ margin: '20px 0' }}>
      <div className=' tarjeta-estado bg-mbr-color-primario' style={{ color: 'black' }}>
        {props.children}
      </div>
    </div>
  );
};

export default ArrepentimientoEstado;
